import { csv } from "d3";
import { Month, MonthMap } from "../consts";
import { DailyChange, KeyDate, RawYearComparison, RawYearMarkets, YoYMarket, YoYMarketRegion, YoYRegion, YoYTotal } from "./DataTypes";

export async function getYoYTotalData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/YoYTotal.csv`).then(function (data: any): void {
        let tmpData: YoYTotal[] = [];
        data.forEach((item: any) => {
            let currentItem: YoYTotal = {
                Year: item["Year"],
                Month: new Date(item["Year"], MonthMap[item["Month"] as Month], 1),
                YoYChange: item["ConsumptionYoY"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getYoYMarketData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/YoYMarket.csv`).then(function (data: any): void {
        let tmpData: YoYMarket[] = [];
        data.forEach((item: any) => {
            let currentItem: YoYMarket = {
                Year: item["Year"],
                Month: new Date(item["Year"], MonthMap[item["Month"] as Month], 1),
                YoYChange: item["YoY Consumption Change"],
                Market: item["Market Type"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getYoYRegionData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/YoYRegion.csv`).then(function (data: any): void {
        let tmpData: YoYRegion[] = [];
        data.forEach((item: any) => {
            let currentItem: YoYRegion = {
                Year: item["Year"],
                Month: new Date(item["Year"], MonthMap[item["Month"] as Month], 1),
                YoYChange: item["YoY Consumption Change"],
                Region: item["Region"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getYoYMarketRegionData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/YoYRegionMarket.csv`).then(function (data: any): void {
        let tmpData: YoYMarketRegion[] = [];
        data.forEach((item: any) => {
            let currentItem: YoYMarketRegion = {
                Year: item["Year"],
                Month: new Date(item["Year"], MonthMap[item["Month"] as Month], 1),
                YoYChange: item["YoY Consumption Change"],
                Market: item["Market Type"],
                Region: item["Region"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getRawYearData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/RawConsumption.csv`).then(function (data: any): void {
        let tmpData: RawYearComparison[] = [];
        data.forEach((item: any) => {
            let currentItem: RawYearComparison = {
                Year: item["Year"],
                Month: new Date(item["Year"], MonthMap[item["Month"] as Month], 1),
                Consumption: item["Consumption"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getRawYearMarketsData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/RawConsumptionMarkets.csv`).then(function (data: any): void {
        let tmpData: RawYearMarkets[] = [];
        data.forEach((item: any) => {
            let currentItem: RawYearMarkets = {
                Year: item["Year"],
                Month: new Date(item["Year"], MonthMap[item["Month"] as Month], 1),
                Consumption: item["Consumption"],
                Market: item["Market Type"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getDailyChangeData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/YoyByDay.csv`).then(function (data: any): void {
        let tmpData: DailyChange[] = [];
        data.forEach((item: any) => {
            let parts = item["Date"].split('-');
            let currentItem: DailyChange = {
                Date: new Date(parts[0], parts[1] - 1, parts[2]),
                Consumption: Math.round(item["Consumption"]),
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}

export async function getKeyDateData(setFunction: Function) {
    csv(`${process.env.PUBLIC_URL}/KeyDateData.csv`).then(function (data: any): void {
        let tmpData: KeyDate[] = [];
        data.forEach((item: any) => {
            let currentItem: KeyDate = {
                Date: new Date(item["Earliest Date"]),
                DayName: item["Event"],
                Consumption: item["Consumption (kWh)"],
                Year: parseInt(item["Calendar Year"]),
                Market: item["Market Type"]
            }
            tmpData.push(currentItem)
        })
        setFunction(tmpData)
    }).catch(function (err: any) { throw err; })
}